import { useMemo } from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { usePageTitle } from '../../../hooks/usePageTitle';
import { articleSchema, faqSchema, breadcrumbSchema } from '../../../components/enhancements/PageSchema';
import { WHATSAPP, PHONE_DISPLAY } from '../../../data/cluster';
import { getBlogPost } from './registry';

const ORIGIN = 'https://floridaaimarketingexperts.com';

export default function BlogPostPage() {
  const { slug } = useParams<{ slug: string }>();
  const post = slug ? getBlogPost(slug) : undefined;

  const canonical = post ? `${ORIGIN}/blog/${post.slug}` : ORIGIN;

  const schema = useMemo(() => {
    if (!post) return undefined;
    return [
      articleSchema({
        headline: post.h1,
        description: post.metaDescription,
        url: canonical,
        datePublished: post.datePublished,
        authorName: 'Florida AI Marketing Experts',
      }),
      faqSchema(post.faqs),
      breadcrumbSchema([
        { name: 'Home', url: `${ORIGIN}/` },
        { name: 'Blog', url: `${ORIGIN}/blog` },
        { name: post.h1, url: canonical },
      ]),
    ];
  }, [post, canonical]);

  usePageTitle({
    title: post ? `${post.title} | FAME` : 'Blog | FAME',
    description: post?.metaDescription || '',
    keywords: post?.keywords,
    canonical,
    schema,
  });

  if (!post) return <Navigate to="/chatgpt-ads-south-florida-home-services" replace />;

  return (
    <div className="min-h-screen bg-white font-['Inter',sans-serif]">
      <Header />
      <article className="max-w-3xl mx-auto px-6 pt-32 pb-16">
        <Link to="/chatgpt-ads-south-florida-home-services" className="text-teal-600 hover:text-teal-700 text-sm font-semibold">
          ← ChatGPT Ads cluster
        </Link>
        <h1 className="text-4xl md:text-5xl font-bold text-navy-900 mt-4 mb-4 font-display leading-tight">
          {post.h1}
        </h1>
        <p className="text-xl text-navy-600 mb-2">{post.excerpt}</p>
        <p className="text-sm text-navy-600 mb-10">Published {post.datePublished} · Florida AI Marketing Experts</p>
        <div className="cluster-prose">{post.body}</div>

        <div className="mt-12 bg-gradient-to-br from-navy-900 to-navy-800 text-white rounded-2xl p-8 text-center">
          <h2 className="text-2xl font-bold mb-3 font-display">Own the ChatGPT Answer</h2>
          <p className="mb-6 text-white/90">
            Free AI marketing audit or book a ChatGPT Ads strategy call. Managed monthly by FAME.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/audit" className="btn-primary">
              Free AI Marketing Audit
            </Link>
            <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" className="border-2 border-white px-6 py-3 rounded-lg font-bold hover:bg-white/10 transition">
              WhatsApp {PHONE_DISPLAY}
            </a>
          </div>
        </div>
      </article>
      <Footer />
    </div>
  );
}
